import { render, staticRenderFns } from "./educationBrand.vue?vue&type=template&id=7e9e1b84&scoped=true"
import script from "./educationBrand.vue?vue&type=script&lang=js"
export * from "./educationBrand.vue?vue&type=script&lang=js"
import style0 from "./educationBrand.vue?vue&type=style&index=0&id=7e9e1b84&prod&lang=scss&scoped=true"
import style1 from "./educationBrand.vue?vue&type=style&index=1&id=7e9e1b84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9e1b84",
  null
  
)

export default component.exports